import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from '@/components/Layout';
import DynamicMetaTags from '@/components/DynamicMetaTags';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Layout>
      <DynamicMetaTags
        title="404 - Page Not Found | AIZen.tips"
        description="The page you're looking for doesn't exist. Return to AIzen.tips to explore our AI solutions directory."
        canonical={`https://aizen.tips${location.pathname}`}
        noIndex={true}
      />
      
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
          <p className="text-xl text-gray-600 mb-4">This page does not exist</p>
          <p className="text-gray-500 mb-6">The requested URL was not found on this server.</p>
          <a href="/" className="text-blue-500 hover:text-blue-700 underline">
            Return to Home
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
